(function () {
    'use strict';

    angular.module("imApp").factory("requisitionPlanViewService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 824,
                    parameters: parms || {}
                });
            },
            listRequisitionPlanViews: function (parms) {
                return $ihttp.post({
                    method: 825,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
